import * as React from "react";

import { baseReturnType, baseSearchObject, IUseSearchApiOptions, useSearchApi } from "nsitools-react";
import { useGlobalData } from "../contexts";

export function useSearchApiWithLanguageRefresh<TSearch extends baseSearchObject, TResults extends baseReturnType>(
  options: IUseSearchApiOptions<TResults, TSearch>
) {
  const { currentLanguage } = useGlobalData();

  const searchApiresults = useSearchApi(options);
  const { search } = searchApiresults;
  React.useEffect(() => {
    if (currentLanguage) {
      search();
    }
  }, [currentLanguage, search]);

  return searchApiresults;
}
